import { useEffect } from 'react';

import { brand } from '@/config/brand';

/** 문서 타이틀 — `{title} · AdvisorDesk`. title 없으면 브랜드명만. */
export function useDocumentTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} · ${brand.name}` : brand.name;
  }, [title]);
}
